module.exports = __webpack_public_path__ + "img/C00020.878fa8e7.png";